// Пространство (задача 59, команды): личное или команда пользователя. Выбирается переключателем
// в шапке, хранится в браузере отдельно для каждого пользователя и уходит с каждым запросом к core
// и data заголовком X-Sl-Space ("personal" или номер команды). Без заголовка сервер работает в
// личном пространстве, как до команд.
const PREFIX = 'sl_space:'

function key(userKey) {
  return `${PREFIX}${userKey || 'anon'}`
}

// who the choice is kept for: the e-mail of the signed-in user (GET /users/me has no id)
export function userKeyOf(userInfo) {
  return (userInfo && userInfo.email && String(userInfo.email).toLowerCase()) || null
}

export function currentSpace(userKey) {
  try {
    return localStorage.getItem(key(userKey)) || 'personal'
  } catch (e) {
    return 'personal'
  }
}

export function setSpace(userKey, space) {
  try {
    if (!space || space === 'personal') localStorage.removeItem(key(userKey))
    else localStorage.setItem(key(userKey), String(space))
  } catch (e) {
    // storage is off: the personal space
  }
}

// the header of a request: the space of the signed-in user
export function spaceHeader(store) {
  return { 'X-Sl-Space': currentSpace(userKeyOf(store && store.state && store.state.userInfo)) }
}
